export const BOOKINGS_API = '/api/dashboard/booking-calendar/booking'
